import { PronunciationMode } from 'src/api/userDictionary/types';
import { ROUTES } from 'src/constants/routes.const';

/**
 * Determines pronunciation mode based on URL context
 * - MY_WORDS: when on /my-words page
 * - BUDDIES_TAB: otherwise
 */
export const getPronunciationModeFromContext = (): PronunciationMode => {
  if (typeof window === 'undefined') {
    return PronunciationMode.BUDDIES_TAB;
  }

  const { pathname } = window.location;
  if (pathname === ROUTES.myWords) return PronunciationMode.MY_WORDS;

  return PronunciationMode.BUDDIES_TAB;
};
